import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import CabinetTransactionMain from "../../components/cabinetTransactionMain";



const CabinetTransactionsPage = () => {
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])


    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetTransactionMain/>
            </div>
        </section>
    );
};

export default CabinetTransactionsPage;
